import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import PDPAddToBagSection from 'components/consumer/PDP/PDPAddToBagSection';
import Placeholder from 'components/consumer/Placeholder';
import PDPGalleryLabelsAndViewingCount from 'components/consumer/PDP/PDPGalleryLabelsAndViewingCount';
import MobileAndTabletOnly from 'components/consumer/MobileAndTabletOnly';
import DesktopOnly from 'components/consumer/DesktopOnly';
import usePdpSetStickyPriceRow from '../state/context/usePdpSetStickyPriceRow';
import PDPRatingsSection from './PDPRatingsSection';
import PDPPriceAndFinance from './PDPPriceAndFinance';
import usePdpSlug from '../state/context/usePdpSlug';
const PDPNameSectionUI = t0 => {
  const $ = _c(37);
  const {
    isEditOrder: t1,
    loading,
    name,
    pdpIsModularBYOProduct: t2,
    subtitle,
    disableStickyPriceRow: t3,
    hideProductLabel: t4,
    hideRatings: t5
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const pdpIsModularBYOProduct = t2 === undefined ? false : t2;
  const disableStickyPriceRow = t3 === undefined ? false : t3;
  const hideProductLabel = t4 === undefined ? false : t4;
  const hideRatings = t5 === undefined ? false : t5;
  const location = useLocation();
  const pdpSlug = usePdpSlug();
  const setStickyPriceRow = usePdpSetStickyPriceRow();
  const nameFromRouterState = location?.state?.name;
  const isNameLoading = loading && !nameFromRouterState;
  const nameToDisplay = loading ? nameFromRouterState : name;
  let t6;
  if ($[0] !== isNameLoading || $[1] !== nameToDisplay) {
    t6 = isNameLoading ? <Placeholder type="rect" loading={true} className="!w-full lg:!w-[310px]" style={{
      height: "23px"
    }} /> : nameToDisplay;
    $[0] = isNameLoading;
    $[1] = nameToDisplay;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== t6) {
    t7 = <h1 className="text-xl font-bold text-gray md:text-2xl md:font-bold pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0 mb-1.5 md:mt-10" data-xc="PDPProductTitle">{t6}</h1>;
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== hideProductLabel) {
    t8 = !hideProductLabel && <MobileAndTabletOnly><div className="flex flex-row items-center lg:hidden"><PDPGalleryLabelsAndViewingCount /></div></MobileAndTabletOnly>;
    $[5] = hideProductLabel;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== t7 || $[8] !== t8) {
    t9 = <div className="flex flex-row items-center">{t7}{t8}</div>;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== subtitle) {
    t10 = subtitle && <div className="pb-1.5 pl-5 md:pl-8 lg:pl-0.5"><span className="text-sm">{subtitle}</span></div>;
    $[10] = subtitle;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== hideRatings || $[13] !== pdpIsModularBYOProduct || $[14] !== pdpSlug) {
    t11 = !hideRatings && <div className="pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0"><PDPRatingsSection key={pdpSlug} pdpIsModularBYOProduct={pdpIsModularBYOProduct} /></div>;
    $[12] = hideRatings;
    $[13] = pdpIsModularBYOProduct;
    $[14] = pdpSlug;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const t12 = disableStickyPriceRow ? undefined : setStickyPriceRow;
  const t13 = !disableStickyPriceRow;
  let t14;
  if ($[16] !== t13) {
    t14 = classNames("bg-white pt-4 px-0 pb-3 lg:items-center lg:flex lg:justify-between lg:px-0 lg:py-5 pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0", {
      "sticky top-0 z-[999]": t13
    });
    $[16] = t13;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== isEditOrder || $[19] !== loading || $[20] !== pdpIsModularBYOProduct || $[21] !== pdpSlug) {
    t15 = <PDPPriceAndFinance isEditOrder={isEditOrder} key={pdpSlug} loading={loading} pdpIsModularBYOProduct={pdpIsModularBYOProduct} />;
    $[18] = isEditOrder;
    $[19] = loading;
    $[20] = pdpIsModularBYOProduct;
    $[21] = pdpSlug;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== disableStickyPriceRow || $[24] !== isEditOrder || $[25] !== loading) {
    t16 = !isEditOrder && !disableStickyPriceRow && <DesktopOnly><div className="ml-2 max-[1023px]:hidden"><PDPAddToBagSection stickyDesktopButtonOnly={true} pageLoading={loading} /></div></DesktopOnly>;
    $[23] = disableStickyPriceRow;
    $[24] = isEditOrder;
    $[25] = loading;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t12 || $[28] !== t14 || $[29] !== t15 || $[30] !== t16) {
    t17 = <div ref={t12} className={t14}>{t15}{t16}</div>;
    $[27] = t12;
    $[28] = t14;
    $[29] = t15;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t10 || $[33] !== t11 || $[34] !== t17 || $[35] !== t9) {
    t18 = <>{t9}{t10}{t11}{t17}</>;
    $[32] = t10;
    $[33] = t11;
    $[34] = t17;
    $[35] = t9;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  return t18;
};
PDPNameSectionUI.propTypes = {
  isEditOrder: PropTypes.bool,
  loading: PropTypes.bool,
  name: PropTypes.string,
  pdpIsModularBYOProduct: PropTypes.bool,
  subtitle: PropTypes.string,
  disableStickyPriceRow: PropTypes.bool,
  hideProductLabel: PropTypes.bool,
  hideRatings: PropTypes.bool
};
export default PDPNameSectionUI;